<template>
    <v-dialog v-model="dialogProp" persistent width="1366">
        <v-card>
            <v-toolbar color="secondary" dark dense>
                <v-spacer></v-spacer>
                Split Order
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-form ref="form" lazy-validation>

                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="text-center">Order</th>
                                <th class="text-center">L1</th>
                                <th class="text-center">L2</th>
                                <th class="text-center">Station</th>
                                <th class="text-center">Terminal</th>
                                <th class="text-center">Split Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ord, idx) in loads">
                                <td>
                                    <v-chip label=""> {{ ord.OrderID }}</v-chip>
                                </td>
                                <td>{{ loads[0].LoadNum }}</td>
                                <td>{{ (idx + 1) }}</td>
                                <td>{{ ord.StationName }}</td>
                                <td>{{ ord.TerminalName }}</td>
                                <td>

                                    <v-combobox v-model="ord.SplitTypeID" :items="split_types"
                                        :item-text="'SplitTypeName'" :item-value="'SplitTypeID'" class="mx-3" required
                                        hide-details dense :rules="[v => !!v || 'Split Type is required']"
                                        auto-select-first></v-combobox>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-form>
                <v-row justify="end">
                    <v-col cols="1" style="margin-top: 15px;">
                        <v-btn small color="secondary" @click="validate">Save</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['loads', 'dialogProp','ShiftDetail'],

    data() {
        return {
            localLoads: this.loads,
            split_types: [],
            split_type: []
        };
    },

    mounted() {
        this.loadSplitTypes();
        // this.reorderLoads();
    },
    methods: {
        loadSplitTypes: function () {
            var str = this.$store;
            axios
                .get('split-type')
                .then(response => {
                    this.split_types = response.data;
                    this.localLoads.forEach(x => {
                        const idx = this.split_types.findIndex(y => {
                            return x.SplitTypeID == y.SplitTypeID;
                        });
                        console.log('here', idx)
                        if(idx >= 0){
                            x.SplitTypeID = this.split_types[idx];
                        }

                    });
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
            console.log(this.split_types);
        },
        async reorderLoads() {
            let LoadNum;
            let loadNumOrd = 1;
            console.log(this.localLoads)
            for (const index in this.localLoads) {
                if (index == 0) {
                    LoadNum = this.localLoads[index].LoadNum;
                    this.localLoads[index].LoadNumOrd = loadNumOrd;
                    loadNumOrd++;
                } else {
                    console.log(this.localLoads[index].LoadNum, this.localLoads[index].LoadNumOrd, this.localLoads[index].OrderID,)
                    this.localLoads[index].LoadNum = LoadNum;
                    this.localLoads[index].LoadNumOrd = loadNumOrd;
                    loadNumOrd++;
                }
            }
           
        },
        async validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
              await  this.reorderLoads();
              this.updateLoads();
            }
        },
        updateLoads: function (){
            var parms = this.localLoads.map( x => {
                return {
                  OrderID : x.OrderID,
                  LoadNum : x.LoadNum,
                  LoadNumOrd : x.LoadNumOrd,
                  SplitTypeID : x.SplitTypeID.SplitTypeID  
                }
            });
            console.log(parms);
            axios.post('dispatch-plan-b/order/update/split/' + this.ShiftDetail , parms)
                .then(response => {
                    this.$emit('save-close');
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        
    }
}

</script>